import { Component, OnInit, output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/components/base/base.component';
import { NotificationService } from '@app/services/notifications.service';
import { encodingBase64 } from '@app/components/base/encodingB64';
const UPP = 'upp';
const UPM = 'upm';
@Component({
  selector: 'app-modal-diro-login',
  templateUrl: './modal-diro-login.component.html',
  styleUrls: ['./modal-diro-login.component.scss'],
})
export class ModalDiroLoginComponent extends BaseComponent implements OnInit {
  form: FormGroup;

  isLoading: boolean = false;
  isEnabled: boolean = false;
  readonly closed = output<ReturnType<typeof this.getModel> | void>();

  constructor(
    private fb: FormBuilder,
    private notificationsService: NotificationService
  ) {
    super();
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      mail: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    this.form.valueChanges.subscribe(() => {
      this.enableSave();
    });
  }

  enableSave() {
    this.isEnabled = this.form.valid;
  }

  onClose(): void {
    // this.dialogRef.close();
    this.closed.emit();
  }

  onLogin(): void {
    // this.dialogRef.close(this.getModel());
    this.closed.emit(this.getModel());
  }

  getModel() {
    let model = {
      upm: encodingBase64(this.form.controls['mail'].value),
      upp: encodingBase64(this.form.controls['password'].value),
    };
    window.sessionStorage.setItem(UPP, model.upp);
    window.sessionStorage.setItem(UPM, model.upm);
    return model;
  }
}
